import { proxy } from "valtio";
import { useProxy } from "valtio/utils";

const overlayModal = proxy({
  open: false,
  x: 0,
  y: 0,
  offset: 320,
  name: "",
  logo: "",
  info: "",
  index: false,
});
// const overlayModalX = proxy({ x: 0 });
// const overlayModalY = proxy({ y: 0 });

export const useOverlayModal = () => useProxy(overlayModal);
// export const useOverlayModalX = () => useProxy(overlayModalX)
// export const useOverlayModalY = () => useProxy(overlayModalY)
